/**
 * Consultant lifecycle status (computed server-side).
 * Shown as a low-prominence pill on the "Current" tab only.
 * See handover §4 "Consultant status (lifecycle)".
 */
export enum ConsultantStatus {
  NotStarted = 0,
  Active = 1,
  EndingSoon = 2,
  Ended = 3,
}
